import React from 'react';
import { View, type ViewProps } from 'react-native';

import {
  type AlertContainerPalette,
  paletteBorderStyles,
  paletteStyles,
} from './AlertContainer.palettes';
import { type AlertContainerSize, sizeStyles } from './AlertContainer.sizes';

// ─────────────────────────────────────────────────────────────────────────────

export const AlertContainer = (props: AlertContainerProps) => {
  const { palette, children, style, size = 'md', hasBorder = false, ...restProps } = props;

  const containerStyles = [
    sizeStyles[size],
    paletteStyles[palette],
    hasBorder ? paletteBorderStyles[palette] : undefined,
    style,
  ];

  return (
    <View style={containerStyles} {...restProps}>
      {children}
    </View>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type AlertContainerProps = {
  size?: AlertContainerSize;
  palette: AlertContainerPalette;
  hasBorder?: boolean;
} & ViewProps;
